import { useState, useEffect, useMemo } from 'react';
import {
    Box, Card, TextField, Autocomplete, Tooltip, Table, TableHead, TableRow, TableCell, TableBody,
    Paper, IconButton, ListItem, ListItemText, Divider, Button
} from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { renderTitle, renderIconButton, TemplatePopup } from "./SarasCommonComp";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { qDoctorAppointmentId } from '../../../../Utility/Services/DoctorPatientQueryIds';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { withTranslation } from 'react-i18next';
import ShowComponents from '../Common/ShowComponent';
import { CommonDeleteButton, CommonEditButton, DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import DeleteIcon from '@mui/icons-material/Delete';

const headers = ['Systematic Examination', 'Signs', 'Notes', 'Action'];

const SarasExamination = ({ Title, ...props }) => {
    const [state, setState] = useState({
        examinationData: [],
        sytematicExam: null,
        sytemicExamList: [],
        signs: null,
        signsList: [],
        comments: "",
        commentsList: [],
        updateId: null,
        // template state
        templateList: [],
        selectedTemplateName: null,
        openPopupAddNew: false,
        templateName: '',
        deleteTemplateName: {},
        tempType: '',
        deletePopup: false,
        templateLoad: false,
        removeData: false,
        // delete Suggestion state
        deleteKey: "",
        deleteSuggObj: null,
        deleteSuggClk: false,
        removeSuggData: false,
        removeLineData: false,
        selectedId:null,
        isEdit:false
    });

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            try {
                if (props?.isSelected && e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'g') {
                    e.preventDefault();
                    updateState({ openPopupAddNew: true, tempType: 'Add' })
                }
            } catch (err) {
                console.error('KeyDown failed:', err);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [props?.isSelected]);

    useEffect(() => {
        if (state.selectedTemplateName) {
            const newData = state.selectedTemplateName?.line_items?.map(item => ({ ...item, id: null }));
            const arr = [...(state.examinationData || []), ...(newData || [])];
            postExamination(arr);
        }
    }, [state.selectedTemplateName])

    const getApiCall = () => {
        getExaminationData();
        getTemplateData();
        getSystemicData();
    }

    const getExaminationData = () => {
        const { appointmentId, clinicId, doctor_id, admission_id } = props
        try {
            let params = props?.fromIp ?
                Serviceurls.SAR_IP_DOC_NOTES_EXAMINATION + `?ip_admission_id=${admission_id}&doctor_id=${doctor_id}&clinic_id=${clinicId}`
                : Serviceurls.SARAS_DOC_EXAMINATION_GET + `?appointment_id=${qDoctorAppointmentId(appointmentId)}`
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ examinationData: response?.data?.data || [], })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        }
        catch (e) {
            props.errorMessage(e.message)
        }
    }

    const getTemplateData = () => {
        try {
            let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_EXAMINATION_TEMP_GET + `?clinic_id=${props?.clinicId}&ip_admission_id=${props?.admission_id}&doctor_id=${props?.doctor_id}` : Serviceurls.SARAS_DOC_EXAMINATION_TEMP_GET
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === 'success') {
                        updateState({
                            templateList: response.data.data
                        })
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const getSystemicData = () => {
        try {
            const { appointmentId, clinicId, doctor_id, admission_id } = props
            let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_EXAMINATION_SUGG_GET + `?ip_admission_id=${admission_id}&doctor_id=${doctor_id}&clinic_id=${clinicId}` : Serviceurls.SARAS_DOC_EXAMINATION_SUGG_GET
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ sytemicExamList: response?.data?.data || [], })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        }
        catch (e) {
            props.errorMessage(e.message)
        }
    }

    const postExamination = (examArr = []) => {
        const { appointmentId } = props
        try {
            const data = {
                appointment_id: appointmentId,
                examination: examArr?.length
                    ? examArr
                    : [
                        {
                            "id": state.selectedId ? state.selectedId : null,
                            "systematic_examination": state.sytematicExam?.systematic_examination ? state.sytematicExam?.systematic_examination : state.sytematicExam || "",
                            "signs": state.signs?.signs ? state.signs?.signs : state.signs || "",
                            "comments": state.comments?.comments ? state.comments?.comments : state.comments || "",
                        }
                    ],
            };

            if (props?.fromIp) {
                data['clinic_id'] = props?.clinicId || null
                data['ip_admission_id'] = props?.admission_id || null
                data['doctor_id'] = props?.doctor_id || null
            }
            let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_EXAMINATION : Serviceurls.SARAS_DOC_EXAMINATION_GET
            updateState({ postLoading: true })
            RestAPIService.create(data, params)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        props.successMessage(response?.data?.message)
                        onClearHandler()
                        getExaminationData();
                        getTemplateData();
                        getSystemicData();
                        updateState({ postLoading: false })
                        if (props?.fromIp) {
                            props?.callHistory(true)
                        }
                    }
                }).catch((error) => {
                    updateState({ postLoading: false })
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ postLoading: false })
            props.errorMessage(error.message)
        }
    }

    const postNewTemplateData = () => {
        try {
            updateState({ templateLoad: true })
            const data = {
                "id": state.tempType === 'rename' ? state.selectedTemplateName?.id : null,
                "template_name": state.templateName,
                "line_items": state.examinationData
            }
            if (props?.fromIp) {
                data['clinic_id'] = props?.clinicId || null
                data['doctor_id'] = props?.doctor_id || null
                data['ip_admission_id'] = props?.admission_id || null
            }
            if (!state.templateName) {
                props.errorMessage("Please enter template name")
                updateState({ templateLoad: false })
            } else if (state.examinationData?.length === 0) {
                props.errorMessage(`Please enter ${Title} data`)
                updateState({ templateLoad: false })
            } else {
                let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_EXAMINATION_TEMP_GET : Serviceurls.SARAS_DOC_EXAMINATION_TEMP_GET
                RestAPIService.create(data, params)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            props.successMessage(response.data.message)
                            updateState({
                                templateLoad: false,
                                openPopupAddNew: false,
                                templateName: '',
                                selectedTemplateName: '',
                                isEdit: false
                            })
                            getTemplateData()
                        }
                    }).catch((error) => {
                        updateState({ templateLoad: false })
                        props.errorMessage(error?.response?.data?.message || error.message)
                    })
            }
        } catch (error) {
            updateState({ templateLoad: false })
            props.errorMessage(error.message)
        }
    }

    const deleteLinePop = () => {
        updateState({
            dltLineClk: false,
            deleteLineItem: null,
            removeLineData: false,
        })
    }

    const deleteLineItem = () => {
        try {
            updateState({ removeLineData: true });
            let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_EXAMINATION : Serviceurls.SARAS_DOC_EXAMINATION_GET
            RestAPIService.delete(`${params}?id=${state.deleteLineItem?.id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        props.successMessage(response.data.message);
                        deleteLinePop();
                        getExaminationData();
                    }
                })
                .catch(e => {
                    updateState({ removeLineData: false });
                    props.errorMessage(e.response.data.message || e.message)
                });
        } catch (e) {
            updateState({ removeLineData: false });
            props.errorMessage(e.message);
        }
    }
    const deleteTemplateData = () => {
        try {
            updateState({ removeData: true });
            let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_EXAMINATION_TEMP_GET : Serviceurls.SARAS_DOC_EXAMINATION_TEMP_GET
            RestAPIService.delete(`${params}?id=${state.deleteTemplateName?.id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        props.successMessage(response.data.message);
                        updateState({
                            openPopupAddNew: false,
                            deleteTemplateName: {},
                            selectedTemplateName: '',
                            deletePopup: false,
                            removeData: false,
                            isEdit: false
                        });
                        getTemplateData();
                    }
                })
                .catch(e => {
                    updateState({ removeData: false });
                    props.errorMessage(e.response.data.message || e.message)
                });
        } catch (e) {
            updateState({ removeData: false });
            props.errorMessage(e.message);
        }
    }

    const deleteSuggestCls = () => {
        updateState({
            deleteKey: "",
            deleteSuggObj: null,
            deleteSuggClk: false,
            signsList: [],
            commentsList:[],
            removeSuggData: false,
            sytematicExam:null,
            comments:null,
            signs:null
        })
    }

    const deleteSuggestData = () => {
        try {
            updateState({ removeSuggData: true });
            let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_EXAMINATION_SUGG_GET : Serviceurls.SARAS_DOC_EXAMINATION_SUGG_GET
            RestAPIService.delete(`${params}?${state.deleteKey === 'comments' ? 'comment_id=' : state.deleteKey === "signs" ? "sign_id=" : "exam_id="}${state.deleteSuggObj?.id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        props.successMessage(response.data.message);
                        deleteSuggestCls();
                        getSystemicData();
                    }
                })
                .catch(e => {
                    updateState({ removeSuggData: false });
                    props.errorMessage(e.response.data.message || e.message)
                });
        } catch (e) {
            updateState({ removeSuggData: false });
            props.errorMessage(e.message);
        }
    }

    const onClearHandler = () => {
        updateState({
            sytematicExam: null,
            signs: null,
            comments: "",
            signsList: [],
            commentsList: [],
            selectedId:null,
            isEdit:false
        })
    }

    const renderAutoComplete = (label, statekey, list, showKey) => {
        const selectedValue = state[statekey] || "";
        return (
            <Autocomplete
                size="small"
                options={list || []}
                sx={{ width: "100%" }}
                getOptionLabel={(option) => (typeof option === "string" ? option : option[showKey] || "")}
                value={selectedValue}
                freeSolo
                disableClearable
                onChange={(event, newValue) => {
                    if (statekey === "sytematicExam") {
                        if (newValue) {
                            updateState({
                                sytematicExam: newValue,
                                signsList: newValue?.signs || [],
                                commentsList: newValue?.comments || []
                            });
                        } else {
                            onClearHandler()
                        }
                    } else if (statekey === 'comments') {
                        updateState({ comments: newValue });
                    } else {
                        updateState({ signs: newValue });
                    }
                }}
                renderOption={(props, option) => (
                    <li {...props} style={{ padding: '0vh 1.5vh' }}>
                        <ListItem sx={{ display: 'flex', justifyContent: 'space-between', p: 0, m: 0 }}>
                            <ListItemText
                                primary={
                                    option[showKey]?.length > 30 ? (
                                        <Tooltip title={option[showKey]} placement="top">
                                            <div>{option[showKey]?.slice(0, 21) + '...'}</div>
                                        </Tooltip>
                                    ) : (
                                        option[showKey]
                                    )
                                }
                            />
                            <Tooltip title={`Delete ${label}`} placement="top" arrow>
                                <IconButton
                                    edge="end"
                                    color="error"
                                    disabled={state.deleteSuggClk}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        updateState({
                                            deleteKey: statekey,
                                            deleteSuggObj: option,
                                            deleteSuggClk: true,
                                        })
                                    }}
                                >
                                    <DeleteIcon sx={{ height: '2.5vh', width: '2.5vw' }} />
                                </IconButton>
                            </Tooltip>
                        </ListItem>
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        size='small'
                        label={label}
                        autoComplete="off"
                        inputProps={{
                            ...params.inputProps,
                            maxLength: 75,
                        }}
                        onChange={(event) => {
                            if (event.target.value) {
                                updateState({ [statekey]: event.target.value });
                            } else {
                                onClearHandler()
                            }

                        }}
                    />
                )}
            />
        );
    };

    const renderComments = () => {
        return (<TextField
            sx={{ width: "100%" }}
            value={state.comments || ""}
            disabled={props.isLocked}
            multiline
            size='small'
            maxRows={2}
            variant="outlined"
            inputProps={{ emed_tid: 'reviewPlan_comments_testId', maxLength: 250 }}
            onChange={(e) => {
                const { value } = e.target;
                updateState({
                    comments: value,
                })
            }}
        />)
    }

    const TemplateActionButton = ({ label, onClick }) => (
        <Button
            color="primary"
            fullWidth
            sx={{ justifyContent: 'flex-start', pl: 2, textTransform: 'capitalize' }}
            onMouseDown={(e) => {
                e.preventDefault();
                onClick();
            }}
        >
            {label}
        </Button>
    );

    const renderSrchTemp = () => {
        return (<Autocomplete
            clearIcon
            size="small"
            disabled={props.isLocked}
            sx={{ width: '16vw' }}
            options={state.templateList}
            value={state.selectedTemplateName}
            getOptionLabel={(option) => typeof option === 'string' ? option : option?.template_name}
            onChange={(e, value) => {
                updateState({
                    selectedTemplateName: value,
                });
            }}
            renderOption={(props, option) => (
                <li {...props} style={{ padding: '0vh 1.5vh' }}>
                    <ListItem sx={{ display: 'flex', justifyContent: 'space-between', p: 0, m: 0 }}>
                        <ListItemText
                            primary={
                                option?.template_name?.length > 30 ? (
                                    <Tooltip title={option.template_name} placement="top">
                                        <div>{option.template_name.slice(0, 21) + '...'}</div>
                                    </Tooltip>
                                ) : (
                                    option.template_name
                                )
                            }
                        />
                        <Tooltip title="Delete Template" placement="top" arrow>
                            <IconButton
                                edge="end"
                                color="error"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    updateState({
                                        tempType: 'delete',
                                        deleteTemplateName: option,
                                        deletePopup: true,
                                    })
                                }}
                            >
                                <DeleteIcon sx={{ height: '2.5vh', width: '2.5vw' }} />
                            </IconButton>
                        </Tooltip>
                    </ListItem>
                </li>
            )}
            renderInput={(params) => <TextField {...params} label="Select Template Name" />}
            PaperComponent={({ children }) => (
                <Paper sx={{ maxHeight: '25vw', overflow: 'auto' }}>
                    {children}
                    <Divider />
                    <TemplateActionButton
                        label="Save As Template"
                        onClick={() => updateState({ openPopupAddNew: true, tempType: 'Add' })}
                    />
                    {state.selectedTemplateName && (
                        <TemplateActionButton
                            label="Edit Template"
                            onClick={() =>
                                updateState({
                                    openPopupAddNew: true,
                                    tempType: 'rename',
                                    templateName: state.selectedTemplateName.template_name,
                                })
                            }
                        />
                    )}
                </Paper>
            )}
        />)
    }

    const disableBtn = useMemo(() => {
        return props?.fromIp ? !state.sytematicExam : !(state.sytematicExam || state.signs) || props.isLocked;
    }, [state.sytematicExam, state.signs, props.isLocked]);

    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                    {renderTitle(Title, props.isSelected)}
                    {renderSrchTemp()}
                </Box>
                <Table size='small' stickyHeader aria-label="sticky table" sx={{ maxHeight: '20vw', overflowY: 'auto' }}>
                    <TableHead>
                        <TableRow>
                            {headers.map((text, idx) => (
                                <TableCell
                                    key={idx}
                                    align={headers.length - 1 === idx ? "center" : "left"}
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '0.9vw',
                                        color: Colors.SecondaryText,
                                        backgroundColor: Colors.Background,
                                        px: '0.2vw'
                                    }}
                                >
                                    {text}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow sx={{ height: '3vw', '& td': { px: '0.2vw', verticalAlign: 'middle' } }}>
                            <TableCell align="left" sx={{ width: "13vw" }}>
                                {renderAutoComplete("Systematic Examination", "sytematicExam", state.sytemicExamList, "systematic_examination")}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "14vw" }}>
                                {renderAutoComplete("Signs", "signs", state.signsList, "signs")}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "16vw" }}>
                                {/* {renderComments()} */}
                                {renderAutoComplete("Notes", "comments", state.commentsList, "comments")}
                            </TableCell>
                            <TableCell align="center" sx={{ width: "1vw" }}>
                                {renderIconButton('Add', ImagePaths[disableBtn ? 'DisabledAddIcon' : 'AddIcon'].default, postExamination, disableBtn, "2vw")}
                            </TableCell>
                        </TableRow>
                        {
                            state.examinationData?.length > 0 ? state.examinationData?.map((item, index) => (
                                <TableRow key={index} sx={{ '& td': { pl: '0.3vw', pr: "0.2vw", fontSize: "0.9vw" } }}>
                                    <TableCell align="left">{item?.systematic_examination ? item?.systematic_examination?.length > 18 ?
                                        <Tooltip placement='top' title={item?.systematic_examination} arrow>
                                            <div>{item?.systematic_examination.slice(0, 18) + "..."}</div></Tooltip> :
                                        item?.systematic_examination : "-"}</TableCell>
                                    <TableCell align="left">
                                        {item?.signs ? item?.signs?.length > 18 ?
                                            <Tooltip placement='top' title={item?.signs} arrow>
                                                <div>{item?.signs.slice(0, 18) + "..."}</div></Tooltip> :
                                            item?.signs : "-"}
                                    </TableCell>
                                    <TableCell align="left">
                                        {item?.comments ? item?.comments?.length > 45 ?
                                            <Tooltip placement='top' title={item?.comments} arrow>
                                                <div>{item?.comments.slice(0, 45) + "..."}</div></Tooltip> :
                                            item?.comments : "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                        <Box component={'div'} display={'flex'}>
                                            <CommonEditButton disable={state.dltLineClk || props.isLocked} size={"1.5vw"}
                                                onClick={() => {
                                                    updateState({
                                                       isEdit: true,
                                                       sytematicExam:item?.systematic_examination,
                                                       signs:item?.signs,
                                                       comments:item?.comments,
                                                       selectedId:item?.id,
                                                       signsList:state.sytemicExamList?.find(s => s?.systematic_examination === item?.systematic_examination)?.signs || [],
                                                       commentsList:state.sytemicExamList?.find(s => s?.systematic_examination === item?.systematic_examination)?.comments || [],
                                                    })
                                                }} />
                                            <CommonDeleteButton disable={state.isEdit || state.dltLineClk || props.isLocked} size={"1.5vw"}
                                                onClick={() => {
                                                    updateState({
                                                        dltLineClk: true,
                                                        deleteLineItem: item,
                                                    })
                                                    if (props?.fromIp) {
                                                        props?.callHistory(true)
                                                    }
                                                }} />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )) : <TableRow>
                                <TableCell colSpan={headers.length} align="center">
                                    No Records To Be Shown
                                </TableCell>
                            </TableRow>}
                    </TableBody>
                </Table>
                {state.openPopupAddNew && <TemplatePopup
                    open={state.openPopupAddNew}
                    onClose={() => updateState({ openPopupAddNew: false, templateName: "" })}
                    templateName={state.templateName || ''}
                    setTemplateName={(value) => updateState({ templateName: value })}
                    tempType={state.tempType}
                    onSubmit={postNewTemplateData}
                    Title={Title}
                // loading={state.templateLoad}
                />}
                {state.deletePopup && <DeletePopup
                    DeletTitle={`Are you sure you want to delete ${state.deleteTemplateName?.template_name} ?`}
                    deleteAlertPopupClose={() => { updateState({ deletePopup: false, isDeleteCliked: false }) }}
                    removeData={deleteTemplateData.bind(this)}
                    disable={state.removeData}
                />}
                {state.deleteSuggClk && <DeletePopup
                    DeletTitle={`Are you sure you want to delete ${state.deleteKey === "signs" ? state.deleteSuggObj?.signs : state.deleteKey === "comments" ? state.deleteSuggObj?.comments : state.deleteSuggObj?.systematic_examination} ?`}
                    deleteAlertPopupClose={deleteSuggestCls}
                    removeData={deleteSuggestData.bind(this)}
                    disable={state.removeSuggData}
                />}
                {state.dltLineClk && <DeletePopup
                    DeletTitle={`Are you sure you want to delete ${state.deleteLineItem?.systematic_examination} ?`}
                    deleteAlertPopupClose={deleteLinePop.bind(this)}
                    removeData={deleteLineItem.bind(this)}
                    disable={state.removeLineData}
                />}
            </Card>
        </ShowComponents >
    )
}

export default withTranslation()(SarasExamination)